import { createSlice } from "@reduxjs/toolkit";
import { fetchArchiveServicesTeacherData,updateMergeDataToActualData } from "../thunks/archiveServicesThunk";

const archiveServicesTeacherSlice = createSlice({
  name: "archiveServicesTeacher",
  initialState: {
    data: [{
            "regionType": "",
            "regionCode": "",
            "yearId": 11,
            "location": "India",
            
    }],
    isLoading:true,
    isError:false,
    error:null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchArchiveServicesTeacherData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchArchiveServicesTeacherData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchArchiveServicesTeacherData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })

      .addCase(updateMergeDataToActualData.fulfilled, (state, action) => {
        state.data.data = action.payload;
        state.isLoading = false;
      })
  },
});

export default archiveServicesTeacherSlice.reducer;